import React from "react";
import PropTypes from "prop-types";
import { Wrapper, Inner, Text, Spinner } from "./styles/loading-styles";
import spinner from "./img/loading.gif";

const Loading = ({ fontSize }) => (
  <Wrapper>
    <Inner>
      <Spinner src={spinner} alt="Loading spinner" />
      <Text fontSize={fontSize}>Loading...</Text>
    </Inner>
  </Wrapper>
);

Loading.propTypes = {
  fontSize: PropTypes.string,
};

Loading.defaultProps = {
  fontSize: PropTypes.isNull,
};

export default Loading;
